import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { AccountStatus } from 'cat-shared/utils'
import { FormName } from 'client/utils'
import { getAccountStatus, getAssetUrl } from 'client/services'

import {
  useAppContext,
  useModalDialogContext,
  usePage,
  usePageStateContext,
} from 'client/hooks'

import {
  AppButton,
  AppDivider,
  AppGroup,
  AppHeader,
  AppImage,
  AppModalDialog,
  AppParagraph,
} from 'client/ui-building-blocks'

const NoAccessModal = () => {
  const { t } = useTranslation()

  const { authUser } = useAppContext()
  const { setAuthForm, setListActiveQuestionId } = usePageStateContext()
  const accountStatus = getAccountStatus(authUser)

  const { navigateTo } = usePage()

  const { showNoAccessModal, toggleNoAccessModal, toggleQuestionModal } =
    useModalDialogContext()

  const MSG_TEXT = useMemo(() => {
    return {
      [AccountStatus.UNKNOWN]: t(
        'app.modals.noAccess.description.actionNotAllowedReasonOne'
      ),
      [AccountStatus.CREATED]: t(
        'app.modals.noAccess.description.actionNotAllowedReasonTwo'
      ),
      [AccountStatus.CONFIRMED]: t(
        'app.modals.noAccess.description.actionNotAllowedReasonThree'
      ),
    }
  }, [t])

  const onClose = () => {
    toggleNoAccessModal(false)
  }

  const onRegister = () => {
    setAuthForm(FormName.RegistrationForm)
    toggleNoAccessModal(false)
    toggleQuestionModal(false)
    setListActiveQuestionId(null)
    navigateTo({ path: '/auth' })
  }

  const onLogin = () => {
    setAuthForm(FormName.AuthenticationForm)
    toggleNoAccessModal(false)
    toggleQuestionModal(false)
    setListActiveQuestionId(null)
    navigateTo({ path: '/auth' })
  }

  return (
    <AppModalDialog
      size="tiny"
      open={showNoAccessModal}
      onClose={onClose}
      Header={
        <AppHeader
          text={t('app.modals.noAccess.header')}
          iconProps={{ name: 'LOCK', variant: 'info' }}
          dividing
          dividerProps={{ size: 'xsmall' }}
        />
      }
      Content={
        <>
          <AppDivider size="small" />
          <AppImage
            src={getAssetUrl('cat-bot-small.jpg')}
            width="250px"
            height="250px"
            centered
            rounded
            alt="logo"
          />
          <AppDivider />
          <AppParagraph text={MSG_TEXT[accountStatus]} />
          <AppDivider border />
        </>
      }
      Actions={
        <AppGroup gapSize="xxsmall">
          <AppButton
            variant="outlined"
            text={t('common.buttons.close')}
            onClick={onClose}
            position="center"
          />
          {accountStatus !== AccountStatus.CREATED ? (
            <AppButton
              variant="success"
              text={t('common.buttons.register')}
              onClick={onRegister}
            />
          ) : null}
          {accountStatus !== AccountStatus.CREATED ? (
            <AppButton
              variant="success"
              text={t('common.buttons.login')}
              onClick={onLogin}
            />
          ) : null}
        </AppGroup>
      }
    />
  )
}

export default NoAccessModal
